import { useEffect, useState } from "react";
import { Eye, FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function ContractPreview({ cid, version, name, disabled }) {
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!open) return undefined;
    let href;
    api.get(`/contracts/${cid}/export`, { params: { format: "pdf", preview: true }, responseType: "blob" })
      .then((r) => { href = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" })); setUrl(href); })
      .catch((e) => { toast.error(errMsg(e)); setOpen(false); });
    return () => { if (href) URL.revokeObjectURL(href); setUrl(null); };
  }, [open, cid, version]);

  return (
    <>
      <Button variant="outline" disabled={disabled} onClick={() => setOpen(true)} data-testid="contract-preview"><Eye className="h-4 w-4 mr-1" />Anteprima</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent aria-describedby={undefined} className="max-w-5xl w-[95vw] h-[92vh] flex flex-col bg-white p-4" data-testid="contract-preview-dialog">
          <DialogHeader className="flex-row items-center justify-between space-y-0 pr-8">
            <DialogTitle className="font-heading">Anteprima di stampa · versione {version}</DialogTitle>
            {url && <a href={url} download={`Contratto_${name}.pdf`} data-testid="contract-preview-download"><Button size="sm" className="bg-[#0A2540] hover:bg-[#031B33] text-white"><FileDown className="h-4 w-4 mr-1" />Scarica PDF</Button></a>}
          </DialogHeader>
          {url
            ? <iframe src={url} title="Anteprima contratto" className="flex-1 w-full rounded border border-slate-200" data-testid="contract-preview-frame" />
            : <div className="flex-1 flex items-center justify-center text-sm text-slate-500" data-testid="contract-preview-loading"><Loader2 className="h-5 w-5 mr-2 animate-spin" />Preparazione anteprima…</div>}
        </DialogContent>
      </Dialog>
    </>
  );
}
